import React, { ChangeEvent } from 'react';
import useValidateValue, { INVALID_CLASS } from '../../hooks/useValidateValue';
import styles from './ShippingAddress.module.scss';

function Input(props: {
  name: string,
  label: string,
  value: string,
  handleOnChange: (event: ChangeEvent<HTMLInputElement>) => void
}) {
  const {
    name, label, value, handleOnChange,
  } = props;
  const { validationClass, validateValue } = useValidateValue();
  return (
    <>
      <label htmlFor={name} className={styles.label}>
        {label}
        <input
          name={name}
          type="text"
          className={`${styles.input} ${validationClass}`}
          value={value}
          onChange={(evt: ChangeEvent<HTMLInputElement>) => {
            handleOnChange(evt);
            validateValue(name, evt.target.value);
          }}
          maxLength={30}
        />
        {validationClass === INVALID_CLASS && (
        <p className={styles.inputError}>
          Enter Valid
          {' '}
          {label}
        </p>
        )}
      </label>
    </>
  );
}

export default Input;
